import { Box, Chip, Grid, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";
import { LIGHT_GREY } from "styles/oneOffColor";

import { getPlanLimitText } from "../helpers";
import styles from "./styles";

interface Props {
  plan: Plans;
}

const FreePlanCard = ({ plan }: Props) => {
  const { plans, emailSents, subscription } = useContext(SubscriptionContext);
  const totalEmails = plans?.[plan]?.monthly_limit || 0;

  const BENEFITS = [
    {
      icon: "🚀",
      primary: (
        <>
          Send <strong>{totalEmails} emails</strong> per month
        </>
      ),
    },
    {
      icon: "🔑",
      primary: (
        <>
          Get access to <strong>50k+ Brand Contacts</strong>
        </>
      ),
    },
  ];

  return (
    <>
      <Box sx={styles.card}>
        <Box sx={[styles.planTitleCard, { backgroundColor: LIGHT_GREY }]}>
          <Grid container justifyContent="flex-end">
            <Chip
              sx={{ backgroundColor: "white", px: 1 }}
              label={
                <Typography variant="subtitle2" sx={{ fontSize: 13 }}>
                  <strong>Perfect for trying out Bento's pitching tools</strong>
                </Typography>
              }
            ></Chip>
          </Grid>

          <Typography variant="h3" sx={{ mt: 6 }}>
            Free{" "}
          </Typography>
        </Box>

        {BENEFITS.map((benefit, index) => (
          <Grid container key={index} alignItems="center" sx={{ mb: 1.5 }}>
            <Grid
              container
              justifyContent="left"
              alignItems="center"
              item
              xs="auto"
            >
              <Box sx={styles.iconBlock}>{benefit.icon}</Box>
            </Grid>
            <Grid item xs md>
              <Typography component="div">{benefit.primary}</Typography>
            </Grid>
          </Grid>
        ))}
      </Box>

      <Box sx={{ mt: 2 }}>
        {getPlanLimitText(subscription, plan, emailSents)}
      </Box>
    </>
  );
};

export default FreePlanCard;
